import script from "./force-page-reload-button.vue?vue&type=script&lang=js"
export * from "./force-page-reload-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__